import { Pipe, PipeTransform } from '@angular/core';
import { IKeyValueInterface } from '../config'

@Pipe({
  name: 'serverErrorMessage'
})

export class ServerErrorMessagePipe implements PipeTransform {
  transform(keyValuePair: IKeyValueInterface[], key: string): string {
    if (keyValuePair) {
      let error = keyValuePair.find(item => item.key.toLowerCase() == key.toLowerCase());
      if (error)
        return error.value;
    }
    return '';
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipe/server-error.pipe.ts